import { bool } from 'prop-types';
import React, { PureComponent } from 'react';
import { ScrollView } from 'react-native';

import { Location } from '../../components';
import { Consumer } from '../../context';
import { LAYOUT, THEME } from '../../reactor/common';
import {
  Button, Motion, Viewport, Text,
} from '../../reactor/components';
import onElTiempoDomain from '../../common/onElTiempoDomain';
import styles from './Info.style';

const { MOTION: { DURATION } } = THEME;

class Info extends PureComponent {
  static propTypes = {
    visible: bool.isRequired,
  };

  render() {
    const { props: { visible } } = this;
    return (
      <Consumer>
        { ({ info: { location, title, text } = {}, onInfo }) => (
          <Motion
            duration={DURATION / 2}
            style={styles.container}
            timeline={[{ property: 'translateY', value: visible ? 0 : LAYOUT.VIEWPORT.H }]}
          >
            <Viewport scroll={false} styleContent={styles.viewportContent}>
              <Button
                contained={false}
                icon="close"
                onPress={() => onInfo()}
                rounded
                style={onElTiempoDomain() ? styles.buttonTopMoved : styles.button}
              />
              <ScrollView style={styles.content}>
                <Text subtitle>
                  {title}
                </Text>
                <Text>
                  {text}
                </Text>
                { location && <Location {...location} style={styles.location} /> }
              </ScrollView>
            </Viewport>
          </Motion>
        )}
      </Consumer>
    );
  }
}

export default Info;
